import React from "react";
import TwoParticipantScoreboard from "../../scoreboards/common/TwoParticipantScoreboard";
import { getSportScoreboardComponent } from "../../scoreboards";

const LiveScoreboard = ({
  match,
  currentScore,
  isReadOnlyMode,
  connected,
  isMatchActive,
  onScoreIncrease,
  onScoreDecrease,
  onResetScore,
  onResetSetScore,
  onToggleTimeout,
  onCompleteMatch,
  onStartMatch,
  matchDuration,
  isTimeoutActive,
  scoringRules,
  scoringMode,
  onScoringModeChange,
  advancedSupported,
  announcerMuted,
  onAnnouncerToggleMute,
  onAnnouncerRepeat,
  // Inline advanced scoring props
  quickMetrics = [],
  p1Players = [],
  p2Players = [],
  onDirectAction,
  onPlayerSelect,
  // Game state sync (badminton / multi-game sports)
  onGameComplete,
  externalGameState,
  // Server match clock + period reporting (timed boards — LS-B08 / LS-B09)
  serverClock,
  onClockChange,
  onPeriodChange,
}) => {
  const sportName = match?.sport_name || match?.sportName || "";
  const SelectedScoreboard = getSportScoreboardComponent(sportName) || TwoParticipantScoreboard;

  return (
    <SelectedScoreboard
      match={match}
      currentScore={currentScore}
      isReadOnlyMode={isReadOnlyMode}
      connected={connected}
      isMatchActive={isMatchActive}
      onScoreIncrease={onScoreIncrease}
      onScoreDecrease={onScoreDecrease}
      onResetScore={onResetScore}
      onResetSetScore={onResetSetScore}
      onToggleTimeout={onToggleTimeout}
      onCompleteMatch={onCompleteMatch}
      onStartMatch={onStartMatch}
      matchDuration={matchDuration}
      isTimeoutActive={isTimeoutActive}
      scoringRules={scoringRules}
      scoringMode={scoringMode}
      onScoringModeChange={onScoringModeChange}
      advancedSupported={advancedSupported}
      sportName={sportName}
      announcerMuted={announcerMuted}
      onAnnouncerToggleMute={onAnnouncerToggleMute}
      onAnnouncerRepeat={onAnnouncerRepeat}
      quickMetrics={quickMetrics}
      p1Players={p1Players}
      p2Players={p2Players}
      onDirectAction={onDirectAction}
      onPlayerSelect={onPlayerSelect}
      onGameComplete={onGameComplete}
      externalGameState={externalGameState}
      serverClock={serverClock}
      onClockChange={onClockChange}
      onPeriodChange={onPeriodChange}
    />
  );
};

export default LiveScoreboard;
